module.exports = __webpack_public_path__ + "img/third-base-patio.2e55e754.jpeg";